import { createFileRoute } from '@tanstack/react-router'
import React from "react";
import Master_PlayersView from "../../../master/PlayersView.tsx";

export const Route = createFileRoute('/_app/master/players/$player_uid')({
  component: RouteComponent,
})

function RouteComponent() {
  return <Master_PlayersView />
}
